import { InjectionToken } from '@angular/core';
export const HISTORY_SIZE_LIMIT = new InjectionToken<string>(
  'HISTORY_SIZE_LIMIT'
);
